import gql from "graphql-tag";

const ADVOCACY_PAGE_QUERY = gql`
    query{
        advocacyPage{
            Summary_Introduction
            Summary_Content
            Summary_Carousel{
                url
                formats
            }
            stories{
                title
                description
                preview{
                  url
                  formats
                }
            }
            Purpose_Introduction
            Purpose_Content
            Light_Highlight_Section{
                title
                description
                link
            }
            Impact_Title
            Impact_Content
            Impact_Cover{
                url
                formats
            }
            Grey_Highlight_Section{
                title
                description
                link
            }
            charities{
                id
                name
                description
                image{
                    url
                    formats
                }
            }
        }
    }
`;

export default ADVOCACY_PAGE_QUERY